<template>
    <div class="h-12" />
</template>
<script setup>
    const props = defineProps({
        config: Object,
    })
</script>
